export const cleanQueryParams = (params: unknown): any => {
  if (typeof params !== 'object' || params === null) return {}

  const notEmptyOrUndefined = (v: unknown): v is Array<any> | any =>
    (Array.isArray(v) && v.length > 0 && v.every(notEmptyOrUndefined)) ||
    (v !== '' && typeof v !== 'undefined')

  return Object.entries(params).reduce((acc, [k, v]) => {
    if (!!k && k !== 'pageSize' && notEmptyOrUndefined(v)) {
      return {
        ...acc,
        [k]: v,
      }
    }

    return acc
  }, {})
}
